import { TFunction } from 'react-i18next';
import * as Yup from 'yup';
import { Shape } from '../yup_types';

export type IAccountFieldTypes = {
	[ACCOUNT_FORM_FIELDS.ACCOUNT_NAME]: string;
	// [ACCOUNT_FORM_FIELDS.FIRST_NAME]: string;
	// [ACCOUNT_FORM_FIELDS.LAST_NAME]: string;
	// [ACCOUNT_FORM_FIELDS.EMAIL]: string;
	// [ACCOUNT_FORM_FIELDS.PHONE]: string;
};

type IAccountFormattedFields = {
	name: string,
	// firstName: string,
	// lastName: string,
	// phone: string,
	// email: string,
};

export enum ACCOUNT_FORM_FIELDS {
	ACCOUNT_NAME = 'Name',
	// FIRST_NAME = 'FirstName',
	// LAST_NAME = 'LastName',
	// EMAIL = 'Email',
	// PHONE = 'Phone'
}

export enum ACCOUNT_FORM_FIELDS_NAMES {
	ACCOUNT_NAME = 'ACCOUNT.ACCOUNT_NAME',
	// FIRST_NAME = 'PARTNERS.LABEL.FIRST_NAME',
	// LAST_NAME = 'PARTNERS.LABEL.LAST_NAME',
	// EMAIL = 'PARTNERS.LABEL.EMAIL',
	// PHONE = 'PARTNERS.LABEL.PHONE'
}

export const getAccountDetailsSchema = (t: TFunction): Yup.SchemaOf<IAccountFieldTypes> => Yup.object<Shape<IAccountFieldTypes>>().shape({
	[ACCOUNT_FORM_FIELDS.ACCOUNT_NAME]: Yup.string()
		.required(t('ACCOUNT.ACCOUNT_NAME_REQUIRED')),
	// [ACCOUNT_FORM_FIELDS.FIRST_NAME]: Yup.string()
	// 	.required(t('PARTNERS.VALIDATION.FIRST_NAME_REQUIRED')),
	// [ACCOUNT_FORM_FIELDS.LAST_NAME]: Yup.string()
	// 	.required(t('PARTNERS.VALIDATION.LAST_NAME_REQUIRED')),
	// [ACCOUNT_FORM_FIELDS.EMAIL]: Yup.string()
	// 	.email(t('PARTNERS.VALIDATION.EMAIL_EXAMPLE'))
	// 	.required(t('PARTNERS.VALIDATION.EMAIL_REQUIRED')),
	// [ACCOUNT_FORM_FIELDS.PHONE]: Yup.string()
	// 	.max(12, t('PARTNERS.VALIDATION.PHONE_LENGTH'))
	// 	.required(t('PARTNERS.VALIDATION.PHONE_REQUIRED'))
});

export const accountInitialValues: IAccountFieldTypes = {
	[ACCOUNT_FORM_FIELDS.ACCOUNT_NAME]: '',
	// [ACCOUNT_FORM_FIELDS.FIRST_NAME]: '',
	// [ACCOUNT_FORM_FIELDS.LAST_NAME]: '',
	// [ACCOUNT_FORM_FIELDS.EMAIL]: '',
	// [ACCOUNT_FORM_FIELDS.PHONE]: ''
};

export const convertToAccountInitialValues = (data): IAccountFieldTypes => ({
	[ACCOUNT_FORM_FIELDS.ACCOUNT_NAME]: data?.name,
	// [ACCOUNT_FORM_FIELDS.FIRST_NAME]: data?.contact?.firstName,
	// [ACCOUNT_FORM_FIELDS.LAST_NAME]: data?.contact?.lastName,
	// [ACCOUNT_FORM_FIELDS.EMAIL]: data?.contact?.email,
	// [ACCOUNT_FORM_FIELDS.PHONE]: data?.contact?.phone
});

export const getFormattedAccountFields = (formikValues): IAccountFormattedFields => ({
	name: formikValues?.[ACCOUNT_FORM_FIELDS.ACCOUNT_NAME],
	// firstName: formikValues?.[ACCOUNT_FORM_FIELDS.FIRST_NAME],
	// lastName: formikValues?.[ACCOUNT_FORM_FIELDS.LAST_NAME],
	// phone: formikValues?.[ACCOUNT_FORM_FIELDS.PHONE],
	// email: formikValues?.[ACCOUNT_FORM_FIELDS.EMAIL],
});

export interface IFormattedAccountFieldsProps {
	id?: string;
	name: string;
	// firstName: string;
	// lastName: string;
	// phone: string;
	// email: string;
}
